import { FillInBlankPreviewComponent } from './preview/fill-in-blank-preview.component';
import { FillInBlankEditComponent } from './edit/fill-in-blank-edit.component';
import { FillInBlankAiChangePreviewComponent } from './ai-change-preview';
import { FillInBlankGradingComponent } from './grading/fill-in-blank-grading.component';
import { FillInBlankReportComponent } from './report/fill-in-blank-report.component';
import { FillInBlankAnswerComponent } from './answer';
export var FILL_IN_BLANK_REGISTRY = {
  edit: FillInBlankEditComponent,
  preview: FillInBlankPreviewComponent,
  'ai-change-preview': FillInBlankAiChangePreviewComponent,
  grading: FillInBlankGradingComponent,
  report: FillInBlankReportComponent,
  answer: FillInBlankAnswerComponent
};